import { render, staticRenderFns } from "./DNSVSEntry.vue?vue&type=template&id=5e5e6331&scoped=true"
import script from "./DNSVSEntry.vue?vue&type=script&lang=js"
export * from "./DNSVSEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e6331",
  null
  
)

export default component.exports